import React, { useCallback } from 'react';
import { ViewProps } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { useLobbySectionSelection } from '@/feature/lobby/hooks/use-lobby-section-selection';
import { PickemLobbyTabNavigationProp } from '@/navigation/pickem/types';
import { League } from '@/types/api.generated';
import { addResizeParamToURL } from '@/utils/cdn-utils';

import { usePlayerFilters } from '../hooks/use-player-filters';
import { LaunchpadTile } from './LaunchpadTile';

type LeagueButtonTitleProps = {
    league: League;
    testID?: string;
    eventsCount?: number;
    icon?: string;
    selected?: boolean;
    isLive?: boolean;
    updateTab?: () => void;
    onLayout?: ViewProps['onLayout'];
    isLastItem?: boolean;
};

export const PickemLeagueTile = ({
    eventsCount,
    league,
    testID,
    icon,
    isLive,
    selected,
    updateTab,
    onLayout,
    isLastItem,
}: LeagueButtonTitleProps) => {
    const { setParams, navigate } = useNavigation<PickemLobbyTabNavigationProp>();
    const { resetAllFilters } = usePlayerFilters();
    const setSelectedTile = useLobbySectionSelection(state => state.actions.setSelectedTile);

    const leagueName = league === League.NflFullSeason ? League.Nfl : league;

    const handlePress = useCallback(() => {
        // on UFC we always navigate to FantasyEventsSheets
        // on PGA we navigate to FantasyEventsSheets only if there is one event
        if (league === League.Ufc || eventsCount === 1) {
            navigate('FantasyEventsSheets', {
                league,
                eventId: '',
                contextKey: `${league}_${new Date().getTime().toString()}`,
            });
            return;
        }
        if (league) {
            updateTab?.();
            setParams({
                league: leagueName,
            });
            setSelectedTile(leagueName);
            resetAllFilters();
        }
    }, [eventsCount, league, leagueName, navigate, resetAllFilters, setParams, setSelectedTile, updateTab]);

    return (
        <LaunchpadTile
            onLayout={onLayout}
            disabled={league === League.NflFullSeason ? false : !eventsCount}
            icon={icon ? addResizeParamToURL(icon, 96) : undefined}
            label={leagueName}
            onPress={handlePress}
            testID={testID}
            selected={selected}
            isLive={isLive}
            isLastItem={isLastItem}
        />
    );
};
